import React, { useEffect } from 'react';
import { Table } from 'react-bootstrap';
import { LoggedUserContext } from 'contexts/logged-user-context';
import RelatorioService from 'services/relatorio-service';
import RepresentadaService from 'services/representada-service';
import PedidoService from 'services/pedido-service';
import Layout from 'components/layout/base';
import PageTitleCard from 'components/page-title-card';
import Select from 'react-select';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMoneyBill, faFilter, faFileExcel } from '@fortawesome/free-solid-svg-icons';
import lib from '../../../helpers/lib';
import Skeleton from 'react-loading-skeleton';
import '../styles.scss';

export default function Ruptura() {
  const [userData, _] = React.useContext(LoggedUserContext);

  const mesInicialFiltro = new Date(),
    y = mesInicialFiltro.getFullYear(),
    m = mesInicialFiltro.getMonth();

  const [isLoading, setIsLoading] = React.useState(true);

  const [representadas, setRepresentadas] = React.useState([]);
  const [vendedores, setVendedores] = React.useState([]);
  const [categorias, setCategorias] = React.useState([]);
  const [totalCategorias, setTotalCategorias] = React.useState([]);

  const [loadedRepresentadas, setLoadedRepresentadas] = React.useState(false);
  const [loadedVendedores, setLoadedVendedores] = React.useState(false);

  const [filter, setFilter] = React.useState({
    codigoPedido: '',
    representadaId: null,
    mes: m + 1,
    ano: y
  });

  useEffect(() => {
    (async () => {
      await getSelectListVendedor();
      await getRepresentadas();
    })();
  }, []);

  useEffect(() => {
    if (loadedRepresentadas && loadedVendedores) {
      getFaturamentoRuptura();
    }
  }, [loadedRepresentadas, loadedVendedores]);

  useEffect(() => {
    (async () => {
      if (categorias.length > 0) {
        let catTotal = {
          nomeCategoria: ' ',
          valorPedido: +categorias.reduce((acc, item) => acc + item.valorPedido, 0).toFixed(2),
          valorFaturado: +categorias.reduce((acc, item) => acc + item.valorFaturado, 0).toFixed(2),
          valorRuptura: +categorias.reduce((acc, item) => acc + item.valorRuptura, 0).toFixed(2),
          valorTotalNaoFaturado: +categorias
            .reduce((acc, item) => acc + item.valorTotalNaoFaturado, 0)
            .toFixed(2),

          volumePedido: +categorias.reduce((acc, item) => acc + item.volumePedido, 0).toFixed(2),
          volumeFaturado: +categorias
            .reduce((acc, item) => acc + item.volumeFaturado, 0)
            .toFixed(2),
          volumeRuptura: +categorias.reduce((acc, item) => acc + item.volumeRuptura, 0).toFixed(2),
          volumeTotalNaoFaturado: +categorias
            .reduce((acc, item) => acc + item.volumeTotalNaoFaturado, 0)
            .toFixed(2)
        };

        catTotal.porcentagemValorRuptura =
          catTotal.valorPedido !== 0
            ? +((catTotal.valorTotalNaoFaturado * 100) / catTotal.valorPedido).toFixed(4)
            : 0;

        catTotal.porcentagemVolumeRuptura =
          catTotal.volumePedido !== 0
            ? +((catTotal.volumeTotalNaoFaturado * 100) / catTotal.volumePedido).toFixed(4)
            : 0;

        setTotalCategorias([catTotal]);
      }
    })();
  }, [categorias]);

  async function getRepresentadas() {
    const response = await RepresentadaService.selectListAsync();
    if (response?.data) {
      setRepresentadas(response?.data?.data[0]?.options);

      setFilter((prevFilter) => ({
        ...prevFilter,
        representadaId: response?.data?.data[0]?.options[0]?.value
      }));
    }
    setLoadedRepresentadas(true);
  }

  async function getSelectListVendedor() {
    let vendedores = await PedidoService.getSelectListVendedor();
    if (vendedores.data) {
      setVendedores(vendedores.data.data);

      if (vendedores.data.data.length == 1) {
        setFilter((prevFilter) => ({ ...prevFilter, vendedorId: vendedores.data.data[0].value }));
      }
    }
    setLoadedVendedores(true);
  }

  async function getFaturamentoRuptura() {
    setIsLoading(true);

    let resultStatus = await RelatorioService.getFaturamentoRuptura(filter);

    if (resultStatus.data) {
      setCategorias(resultStatus.data);
    }

    setIsLoading(false);
  }

  async function getExtratoRuptura() {
    setIsLoading(true);

    let response = await RelatorioService.getExtratoRuptura(filter);

    if (response?.data) {
      let fileName = `faturamento_ruptura_${lib.getCurrentDateFilename()}.xlsx`;
      lib.downloadFile(response.data.data, fileName);
    }

    setIsLoading(false);
  }

  return (
    <Layout>
      <PageTitleCard title="Ruptura" icon={<FontAwesomeIcon icon={faMoneyBill} />} />

      <div className="background-relatorio">
        {/* Filter ------------------------------------------------------------------------------ */}
        <div className="row filter-bar2 mb-5">
          <div className="col-lg-2">
            <label>Representada</label>
            <Select
              isClearable={false}
              // clearValue={() => {
              //   setFilter({ ...filter, representadaId: null });
              // }}
              styles={customControlStyles}
              placeholder="Selecione..."
              options={representadas}
              value={representadas?.find((x) => x.value === filter.representadaId)}
              onChange={(selectedValue) => {
                setFilter({ ...filter, representadaId: selectedValue?.value });
              }}
            />
          </div>

          <div className="col-lg-2">
            <label>Vendedor</label>
            <Select
              isClearable={vendedores?.length > 1}
              clearValue={() => {
                setFilter({ ...filter, vendedorId: null });
              }}
              styles={customControlStyles}
              placeholder="Selecione..."
              options={vendedores}
              value={vendedores?.find((x) => x.value === filter.vendedorId)}
              onChange={(selectedValue) => {
                setFilter({ ...filter, vendedorId: selectedValue?.value });
              }}
            />
          </div>

          <div className="col-lg-2">
            <label>Mês</label>
            <Select
              className="select-form-control"
              value={lib.selectListMeses?.find((item) => item.value === filter.mes)}
              options={lib.selectListMeses}
              isClearable={false}
              onChange={(item) => {
                setFilter({ ...filter, mes: item.value });
              }}
            />
          </div>

          <div className="col-lg-2">
            <label>Ano</label>
            <Select
              className="select-form-control"
              value={lib.selectListAnos?.find((item) => item.value === filter.ano)}
              options={lib.selectListAnos}
              isClearable={false}
              onChange={(item) => {
                setFilter({ ...filter, ano: item.value });
              }}
            />
          </div>

          <div className="col row">
            <div className="col-6"></div>

            <div className="col-3 align-content-end">
              {/* Botão Exportar --------------------------------------------------------------------- */}
              <button
                type="button"
                className="btn btn-secondary btn-sm btn-action"
                onClick={() => {
                  setFilter({
                    ...filter
                  });
                  getExtratoRuptura();
                }}
                disabled={isLoading}
              >
                <FontAwesomeIcon icon={faFileExcel} /> Exportar
              </button>
            </div>

            <div className="col-3 align-content-end">
              {/* Botão Filtrar --------------------------------------------------------------------- */}
              <button
                type="button"
                className="btn btn-secondary btn-sm btn-action"
                onClick={() => {
                  setFilter({
                    ...filter
                    //pageNumber: 1
                  });
                  getFaturamentoRuptura();
                }}
                disabled={isLoading}
              >
                <FontAwesomeIcon icon={faFilter} /> Filtrar
              </button>
            </div>
          </div>
        </div>

        <div
          className="table-responsive table-historico mt-4"
          onCopy={(e) => lib.parseCopiedText(e)}
        >
          {!isLoading && categorias ? (
            <Table striped bordered hover width="100%" className="table-relatorio">
              <thead>
                <tr>
                  <th colSpan="6" className="text-center">
                    ÍNDICE DE RUPTURA POR CATEGORIA - FATURAMENTO
                  </th>
                </tr>
                <tr>
                  <th>Categoria</th>
                  <th>Pedido</th>
                  {/* <th>Faturado</th>
                  <th>Ruptura</th> */}
                  <th>Não Atendido</th>
                  <th>% Não Atendido</th>
                </tr>
              </thead>
              <tbody>
                {categorias.length > 0 ? (
                  ([...categorias, ...totalCategorias] || [])?.map((item, index) => (
                    <tr key={index} className={index >= categorias.length ? 'fw-700' : ''}>
                      <td>{item.nomeCategoria}</td>
                      <td>
                        {/* {item.valorPedido.toFixed(2)} */}
                        {Math.floor(item.valorPedido).toLocaleString('pt-br', {
                          style: 'currency',
                          currency: 'BRL',
                          maximumFractionDigits: 0
                        })}
                      </td>
                      {/* <td>
                        {Math.floor(item.valorFaturado).toLocaleString('pt-br', {
                          style: 'currency',
                          currency: 'BRL',
                          maximumFractionDigits: 0
                        })}
                      </td>
                      <td>
                        <span className={item.valorRuptura <= 0 ? 'txt-green' : 'txt-red'}>
                          {Math.floor(item.valorRuptura).toLocaleString('pt-br', {
                            style: 'currency',
                            currency: 'BRL',
                            maximumFractionDigits: 0
                          })}
                        </span>
                      </td> */}
                      <td>
                        {/* {item.valorRuptura.toFixed(2)} */}
                        <span className={item.valorTotalNaoFaturado <= 0 ? 'txt-green' : 'txt-red'}>
                          {Math.floor(item.valorTotalNaoFaturado).toLocaleString('pt-br', {
                            style: 'currency',
                            currency: 'BRL',
                            maximumFractionDigits: 0
                          })}
                        </span>
                      </td>
                      <td>
                        <span
                          className={item.porcentagemValorRuptura <= 0 ? 'txt-green' : 'txt-red'}
                        >
                          {lib.formatToNumeric(
                            item.porcentagemValorRuptura,
                            index > categorias.length - 1 ? 4 : 2,
                            //index > categorias.length - 1 ? false : true
                            true
                          )}
                          %
                        </span>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={4}>Nenhum registro encontrado.</td>
                  </tr>
                )}
              </tbody>
            </Table>
          ) : (
            <Skeleton count={10} />
          )}
        </div>

        <div
          className="table-responsive table-historico mt-4"
          onCopy={(e) => lib.parseCopiedText(e)}
        >
          {!isLoading && categorias ? (
            <Table striped bordered hover width="100%" className="table-relatorio">
              <thead>
                <tr>
                  <th colSpan="6" className="text-center">
                    ÍNDICE DE RUPTURA POR CATEGORIA - VOLUME
                  </th>
                </tr>
                <tr>
                  <th>Categoria</th>
                  <th>Pedido</th>
                  {/* <th>Faturado</th>
                  <th>Ruptura</th> */}
                  <th>Não Atendido</th>
                  <th>% Não Atendido</th>
                </tr>
              </thead>
              <tbody>
                {categorias.length > 0 ? (
                  ([...categorias, ...totalCategorias] || [])?.map((item, index) => (
                    <tr key={index} className={index >= categorias.length ? 'fw-700' : ''}>
                      <td>{item.nomeCategoria}</td>
                      <td>{lib.formatToNumeric(item.volumePedido, 3, true)} Kg</td>
                      {/* <td>{lib.formatToNumeric(item.volumeFaturado, 3, true)} Kg</td>
                      <td>
                        <span className={item.volumeRuptura <= 0 ? 'txt-green' : 'txt-red'}>
                          {lib.formatToNumeric(item.volumeRuptura, 3, true)} Kg
                        </span>
                      </td> */}
                      <td>
                        <span
                          className={item.volumeTotalNaoFaturado <= 0 ? 'txt-green' : 'txt-red'}
                        >
                          {lib.formatToNumeric(item.volumeTotalNaoFaturado, 3, true)} Kg
                        </span>
                      </td>
                      <td>
                        <span
                          className={item.porcentagemVolumeRuptura <= 0 ? 'txt-green' : 'txt-red'}
                        >
                          {lib.formatToNumeric(
                            item.porcentagemVolumeRuptura,
                            index > categorias.length - 1 ? 4 : 2,
                            //index > categorias.length - 1 ? false : true
                            true
                          )}
                          %
                        </span>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={4}>Nenhum registro encontrado.</td>
                  </tr>
                )}
              </tbody>
            </Table>
          ) : (
            <Skeleton count={10} />
          )}
        </div>
      </div>
    </Layout>
  );
}
